import { registerPlugin } from '@capacitor/core'
const Card = registerPlugin('Card')
export default Card
